var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEyeClose({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.6317 11.4881C12.0987 12.3867 11.0635 12.8597 10.0353 12.6742C9.0071 12.4888 8.20234 11.684 8.0169 10.6558C7.83146 9.6276 8.30437 8.59241 9.20301 8.05945",
    stroke: "#8A90A2",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.4973 14.3533C14.06 15.4435 12.3042 16.0311 10.5002 16.0256C7.51093 16.0788 4.74897 14.4359 3.36888 11.7838C2.87313 10.779 2.87313 9.60067 3.36888 8.59582C4.05909 7.22134 5.15934 6.09529 6.51746 5.37341",
    stroke: "#8A90A2",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5226 11.9687C17.5561 11.9053 17.5996 11.8485 17.6312 11.7839C18.127 10.7791 18.127 9.60077 17.6312 8.59592C16.2511 5.94377 13.4892 4.30093 10.4999 4.35416C10.3125 4.35416 10.1303 4.37917 9.94531 4.39136",
    stroke: "#8A90A2",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18.0031 16.8593L3.83057 2.68677",
    stroke: "#8A90A2",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeClose);
export default __webpack_public_path__ + "static/media/eye-close.33b578300d696d8e9cb3e2352160f697.svg";
export { ForwardRef as ReactComponent };